
import contrast from 'contrast'

const isLight = (color) => contrast(color) == 'light'

export default {
  name: 'ColorOptions',
  props: {
    value: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: null
    },
    icon: {
      type: String,
      default: 'check'
    },
    size: {
      type: [String, Object],
      default: 'sm'
    },
    circle: {
      type: Boolean,
      default: true
    },
    shadow: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    check: {
      fontSize: 'xl'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.selected = newValue
        }
      }
    }
  },
  data() {
    return {
      selected: null
    }
  },
  methods: {
    onSelect({ value }) {
      this.selected = value
      this.$emit('input', value)
    },
    iconStyle(color) {
      return {
        color: color == 'transparent' ? 'black' : isLight(color) ? 'black' : 'white'
      }
    }
  }
}
